import { AxiosResponse } from 'axios';
import { getNameRegister } from 'civil-status/components/shared/list-register';
import {
  ArchiveAnnotationsListVM,
  ArchivioAnnotazioni,
} from 'civil-status/view-models/archive-annotations-list';
import { DateTime } from 'luxon';
import { HttpResponse } from 'shell/models/http-response';

export const transformListArchiveAnnotations = (
  response: AxiosResponse<HttpResponse<Array<ArchivioAnnotazioni>>>
): Array<ArchiveAnnotationsListVM> => {
  return (response.data as HttpResponse<Array<ArchivioAnnotazioni>>).payload?.map(
    (item) =>
      ({
        id: item.key.idDatiComunicazione,
        practice: item.tipoAttoSecondario || '',
        description: item.testoIntestazione || '',
        dateFormation: item.timestampInserimento
          ? DateTime.fromISO(item.timestampInserimento)?.toFormat('dd/MM/yyyy')
          : null,
        act: `${getNameRegister(item.codRegistroAttoPrimario)} ${item.nrAnnoAttoPrimario || ''} ${
          item.codParteAttoPrimario ? `p.${item.codParteAttoPrimario}` : ''
        } ${item.codSerieAttoPrimario ? `s.${item.codSerieAttoPrimario}` : ''} ${
          item.codVolumeAttoPrimario ? `v.${item.codVolumeAttoPrimario}` : ''
        } ${item.nrAttoPrimario ? `n.${item.nrAttoPrimario}` : ''}`,
        dateRegistration: item.dataRegistrazioneAnnotazione
          ? DateTime.fromISO(item.dataRegistrazioneAnnotazione)?.toFormat('dd/MM/yyyy')
          : '',
        state: item.codStatoComunicazione || '',
        codeState: item.codStatoComunicazione || '',
        rejectReason: item.testoMotivoAnnulloRifiuto || '',
        itemArchivioAnnotazioni: item,
      } as ArchiveAnnotationsListVM)
  );
};
